// extracted by mini-css-extract-plugin
export default {"main":"Home_main__Sg46B","main__cell":"Home_main__cell__HKo4q"};